export default __webpack_public_path__ + "static/media/bell.88925f78.svg";